import { styled } from '@mui/material/styles';

export const SelfRegisterRoot = styled('div')({
  flexGrow: 1,

  '& .titleContainer': {
    maxWidth: 'none',
    alignSelf: 'center',

    '& > div': {
      justifyContent: 'center',
    },
  },
});

export const SelfRegisterContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const SelfRegisterLogoHeader = styled('div')({
  minHeight: 200,
  '& .IMAGE': {
    height: 200,
    margin: 'auto',
  },
});

export const SelfRegisterPerformLogo = styled('div')({
  margin: '0 auto',
  width: 150,
});
